import * as auth from '_core/store/auth.duck';
import { useDispatch } from 'react-redux';

export function setLoginContext(queryParams) {
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(queryParams);
  const loginContext = urlParams.get('loginContext');
  dispatch(auth.actions.updateLoginContext(loginContext));
}
